/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import client from "@kubb/plugin-client/clients/axios";
import type {
	GetBatchTokenMetadataV1TokensMetadataBatchPostMutationRequest,
	GetBatchTokenMetadataV1TokensMetadataBatchPostMutationResponse,
	GetBatchTokenMetadataV1TokensMetadataBatchPostQueryParams,
	GetBatchTokenMetadataV1TokensMetadataBatchPost422,
} from "../models/GetBatchTokenMetadataV1TokensMetadataBatchPost.ts";
import type {
	RequestConfig,
	ResponseErrorConfig,
} from "@kubb/plugin-client/clients/axios";
import type { UseMutationOptions, QueryClient } from "@tanstack/react-query";
import { useMutation } from "@tanstack/react-query";

export const getBatchTokenMetadataV1TokensMetadataBatchPostMutationKey = () =>
	[{ url: "/v1/tokens/metadata/batch" }] as const;

export type GetBatchTokenMetadataV1TokensMetadataBatchPostMutationKey =
	ReturnType<typeof getBatchTokenMetadataV1TokensMetadataBatchPostMutationKey>;

/**
 * @description Retrieve metadata for up to 100 tokens at once. Uses Redis cache and RPC nodes as fallback, following the same logic as individual token endpoints.
 * @summary Get Token Metadata in Batch
 * {@link /v1/tokens/metadata/batch}
 */
export async function getBatchTokenMetadataV1TokensMetadataBatchPostHook(
	data: GetBatchTokenMetadataV1TokensMetadataBatchPostMutationRequest,
	params: GetBatchTokenMetadataV1TokensMetadataBatchPostQueryParams,
	config: Partial<
		RequestConfig<GetBatchTokenMetadataV1TokensMetadataBatchPostMutationRequest>
	> & { client?: typeof client } = {},
) {
	const { client: request = client, ...requestConfig } = config;

	const res = await request<
		GetBatchTokenMetadataV1TokensMetadataBatchPostMutationResponse,
		ResponseErrorConfig<GetBatchTokenMetadataV1TokensMetadataBatchPost422>,
		GetBatchTokenMetadataV1TokensMetadataBatchPostMutationRequest
	>({
		method: "POST",
		url: "/v1/tokens/metadata/batch",
		baseURL: "https://api.sparkscan.io",
		params,
		data,
		...requestConfig,
	});
	return res.data;
}

/**
 * @description Retrieve metadata for up to 100 tokens at once. Uses Redis cache and RPC nodes as fallback, following the same logic as individual token endpoints.
 * @summary Get Token Metadata in Batch
 * {@link /v1/tokens/metadata/batch}
 */
export function useGetBatchTokenMetadataV1TokensMetadataBatchPostHook<TContext>(
	options: {
		mutation?: UseMutationOptions<
			GetBatchTokenMetadataV1TokensMetadataBatchPostMutationResponse,
			ResponseErrorConfig<GetBatchTokenMetadataV1TokensMetadataBatchPost422>,
			{
				data: GetBatchTokenMetadataV1TokensMetadataBatchPostMutationRequest;
				params: GetBatchTokenMetadataV1TokensMetadataBatchPostQueryParams;
			},
			TContext
		> & { client?: QueryClient };
		client?: Partial<
			RequestConfig<GetBatchTokenMetadataV1TokensMetadataBatchPostMutationRequest>
		> & { client?: typeof client };
	} = {},
) {
	const { mutation = {}, client: config = {} } = options ?? {};
	const { client: queryClient, ...mutationOptions } = mutation;
	const mutationKey =
		mutationOptions.mutationKey ??
		getBatchTokenMetadataV1TokensMetadataBatchPostMutationKey();

	return useMutation<
		GetBatchTokenMetadataV1TokensMetadataBatchPostMutationResponse,
		ResponseErrorConfig<GetBatchTokenMetadataV1TokensMetadataBatchPost422>,
		{
			data: GetBatchTokenMetadataV1TokensMetadataBatchPostMutationRequest;
			params: GetBatchTokenMetadataV1TokensMetadataBatchPostQueryParams;
		},
		TContext
	>(
		{
			mutationFn: async ({ data, params }) => {
				return getBatchTokenMetadataV1TokensMetadataBatchPostHook(
					data,
					params,
					config,
				);
			},
			mutationKey,
			...mutationOptions,
		},
		queryClient,
	);
}
